
// @flow

import React, { Component } from 'react';
import type { Node } from 'react';
import { connect } from 'react-redux';
import { getUiSetting } from '../../store/uiStore';
import Slider from './slider';

type OwnProps = {|
  children: Node,
  totalSlides: number,
|};

type StateProps = {|
  sliderEnabled: ?boolean,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

class SliderContainer extends Component<Props> {
  render() {
    const {
      sliderEnabled,
      children,
      ...sliderProps
    } = this.props;

    if (!sliderEnabled) {
      return children;
    }

    return (
      <Slider
        {...sliderProps}
      >
        {children}
      </Slider>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  sliderEnabled: getUiSetting(state, 'slidersEnabled'),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(SliderContainer);
